import React, {
  CSSProperties,
  useEffect,
  useState,
} from 'react';
import {useDispatch} from 'react-redux';
import swal from 'sweetalert2';
import {getEndpoint, getHeaders, getMPPEndpoint} from '../../../helpers/endpoint';
import { VersionEditor } from '../Editor';
import { ChangelogVersion } from '@lfp-digital/back-types-mpg';
import { pick } from 'lodash';

const styles: Record<string, CSSProperties> = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    margin: 16,
  },
  titleContainer: {
    display: 'flex',
    height: 43,
    backgroundColor: 'white',
    width: '100%',
    alignItems: 'center',
    fontSize: 18,
    paddingLeft: 16,
  },
  saveButton: {
    height: 48,
    width: 150,
    color: '#4054CC',
    borderRadius: 4,
    backgroundColor: 'transparent',
    borderWidth: 1,
    borderColor: '#4054CC',
    fontWeight: 'bold',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 16,
  },
  disabledButton: {
    height: 48,
    width: 150,
    color: 'white',
    borderRadius: 4,
    backgroundColor: '#959DAF',
    fontWeight: 'bold',
    borderWidth: 0,
  },
};

const createVersion = (
  isMPP: boolean,
  payload: any,
  onSuccess: (response: ChangelogVersion) => void,
) => {
  return (_dispatch, getState) => {
    return fetch((isMPP ? getMPPEndpoint : getEndpoint)('createVersion'), {
      method: 'POST',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify(payload),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          swal({
            title: `Oops...`,
            type: 'error',
            html: `Something went wrong !<br/>${data.message}<br/>`,
          });
        } else {
          onSuccess(data);
        }
      })
      .catch(() => {});
  };
};

const updateVersion = (
  isMPP: boolean,
  version: any,
  payload: any,
  onSuccess: (response: any) => void,
) => {
  return (_dispatch, getState) => {
    return fetch((isMPP ? getMPPEndpoint : getEndpoint)('version', version), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify(payload),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          swal({
            title: `Oops...`,
            type: 'error',
            html: `Something went wrong !<br/>${data.message}<br/>`,
          });
        } else {
          onSuccess(data);
        }
      })
      .catch(() => {});
  };
};

const getVersion = (
  isMPP: boolean,
  version: string,
  onSuccess: (response: ChangelogVersion) => void,
) => {
  return (_dispatch, getState) => {
    return fetch((isMPP ? getMPPEndpoint : getEndpoint)('version', version), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
        } else {
          onSuccess(data);
        }
      })
      .catch(() => {});
  };
};

export const Version = ({history, match}) => {
  const dispatch = useDispatch();

  const [version, setVersion] = useState<Partial<ChangelogVersion>>({});
  const [error, setError] = useState<boolean>(false);

  console.log({version});

  const versionId = match.params.version;
  const isMPP = match?.path?.includes('mpp');

  const onChange = (key: string, value: string | number) => {
    setError(false);
    console.log({value});
    
    setVersion({...version, [key]: value});
  };

  const onSuccess = (response: ChangelogVersion) => {
    setVersion(response);
  };

  useEffect(() => {
    if (versionId) {
      dispatch(getVersion(isMPP, versionId, onSuccess));
    } else {
      setVersion({});
    }
  }, [versionId]);

  const onSubmit = () => {
    if (version?.version?.match(/^\d{1,3}\.\d{1,3}\.\d{1,3}$/)) {
      const onSuccess = () => {
        history.push(isMPP ? '/mpp/version/list' : '/version/list');
      };
      
      if (versionId) {
        // @ts-ignore
        dispatch(updateVersion(isMPP, versionId, pick(version, ['versionDate', 'status', 'description', 'name', 'imageUrl']), onSuccess));
      } else {
        // @ts-ignore
        dispatch(createVersion(isMPP, pick(version, ['version', 'versionDate', 'description', 'name', 'imageUrl']), onSuccess));
      }
    } else {
      setError(true);
    }
  };

  const isButtonDisabled = !version?.name || !version.versionDate || (versionId ? !version.status : !version?.version);

  return (
    <div style={styles.container}>
      <div style={styles.titleContainer}>{versionId ? 'Update' : 'Create'} version</div>
      <VersionEditor
        onChange={onChange}
        data={version}
        isCreation={!versionId}
        errorForSubmit={!!error}
      />
      <div style={styles.buttonContainer}>
        <button
          disabled={isButtonDisabled}
          style={!isButtonDisabled ? styles.saveButton : styles.disabledButton}
          onClick={onSubmit}>
          Sauvegarder
        </button>
        <span style={{marginLeft: 8, color: 'red'}}>*</span>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pages/Versions/Version/index.tsx